<template>
  <div class="container-fluid py-2">
    <div class="row g-3">
      <div class="col-12">
        <!-- Modern Sticky Tabs Header -->
        <div class="policy-tabs-card card mb-3 shadow-sm">
          <div class="card-body p-2">
            <el-tabs v-model="tabIndex" class="policy-modern-tabs">
              <el-tab-pane :name="0">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-file-earmark-text me-1"></i> Müqavilə</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="3">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-person-badge me-1"></i> Sığorta olunan</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="7">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-cash-stack me-1"></i> Ödəniş</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="6">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-shield-check me-1"></i> Şərtlər</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="12">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-journal-plus me-1"></i> Əlavələr</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="9">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-exclamation-octagon me-1"></i> İstisnalar</span>
                </template>
              </el-tab-pane>
              <el-tab-pane :name="8">
                <template #label>
                  <span class="tab-label-custom"><i class="bi bi-paperclip me-1"></i> Fayllar</span>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <!-- Tab contents -->
        <Info v-if="tabIndex == 0" @toggle-nav="showNav = !showNav"></Info>
        <Insured v-if="tabIndex == 3"></Insured> 
        <Payment v-if="tabIndex == 7"></Payment> 
        <Conditions v-if="tabIndex == 6"></Conditions> 
        <Addendum v-if="tabIndex == 12"></Addendum>
        <Exceptions v-if="tabIndex == 9"></Exceptions> 
        <Files v-if="tabIndex == 8"></Files>
      </div>
    </div>
  </div>
</template>

<script>
import Info from './Components/Info/Main.vue';
import Conditions from './Components/Conditions/Main.vue';
import Insured from './Components/Insured/Main.vue';
import Payment from './Components/Payment/Main.vue';
import Exceptions from './Components/Exceptions/Main.vue';
import Files from './Components/Files/Main.vue';
import Addendum from './Components/Addendum/Main.vue';

export default {
  name: "PolicyMain",
  components: {
    Info,
    Addendum, 
    Insured,
    Files,
    Conditions, 
    Payment, 
    Exceptions
  },
  data() {
    return {
      showNav: true,
      tabIndex: 0,
      priv: []
    };
  }
};
</script>

<style scoped lang="scss">
.policy-tabs-card {
  border: 1px solid var(--app-border, #e2e8f0);
  border-radius: var(--app-radius, 8px);
  background: var(--app-surface, #ffffff);
}

:deep(.policy-modern-tabs) {
  .el-tabs__header {
    margin: 0;
    border-bottom: none;
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-tabs__item {
    font-size: 0.85rem;
    font-weight: 650;
    color: var(--app-text, #64748b);
    padding: 0 16px;
    height: 38px;
    line-height: 38px;
    transition: all 0.15s ease;

    &:hover {
      color: var(--bs-info, #0b4f9c);
    }

    &.is-active {
      color: var(--bs-info, #0b4f9c);
      font-weight: 750;
    }
  }

  .el-tabs__active-bar {
    background-color: var(--bs-info, #0b4f9c);
    height: 3px;
    border-radius: 3px;
  }
}

.tab-label-custom {
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
}

[data-theme="dark"] {
  .policy-tabs-card {
    background: #182029;
    border-color: #2e3846;
  }

  :deep(.policy-modern-tabs) {
    .el-tabs__item {
      color: #94a3b8;

      &:hover {
        color: #60a5fa;
      }

      &.is-active {
        color: #93c5fd;
      }
    }

    .el-tabs__active-bar {
      background-color: #60a5fa;
    }
  }
}
</style>